import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MenuService {
  private _activeMenu = new BehaviorSubject<boolean>(false);
  private _activeSearch = new BehaviorSubject<boolean>(false);
  private _menuAvailable = new BehaviorSubject<boolean>(false);

  get menu(): Observable<boolean> {
    return this._activeMenu.asObservable();
  }

  set menu(state: boolean) {
    this._activeMenu.next(state);
  }

  get search(): Observable<boolean> {
    return this._activeSearch.asObservable();
  }

  set search(state: boolean) {
    this._activeSearch.next(state);
  }

  get menuAvailable(): Observable<boolean> {
    return this._menuAvailable.asObservable();
  }

  set menuAvailable(state: boolean) {
    this._menuAvailable.next(state);
  }
}
